import { render } from "./termsCondition.vue?vue&type=template&id=82071736"
import script from "./termsCondition.vue?vue&type=script&lang=js"
export * from "./termsCondition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__